// Centralized API endpoint paths (mirrors the redeemed-event `endpoints` convention)
// so route strings are not scattered inline across pages/components.
export const ENDPOINTS = {
  auth: {
    sendOtp: '/user/send-otp',
    verifyOtp: '/user/verify-otp',
    register: '/user/register',
    login: '/user/login',
    forgotPassword: '/user/forgot-password',
    resetPassword: '/user/reset-password',
    me: '/user/me',
    profile: '/user/profile',
    changePassword: '/user/change-password',
  },
  rsa: {
    plans: '/rsa/plans',
    members: '/rsa/members',
    myMembership: '/rsa/my-membership',
  },
  blog: {
    list: '/blog',
    bySlug: (slug) => `/blog/slug/${slug}`,
  },
  services: '/services',
  serviceRequests: '/service-requests',
  contacts: '/contacts',
  settings: { public: '/settings/public' },
};
